import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import { GlobalProvider } from './context/provider';
import reportWebVitals from './reportWebVitals';
import 'mapbox-gl/dist/mapbox-gl.css';
import './theme/global.scss';
import axios from 'axios';
import { DeviceTypeProvider } from './deviceType';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import 'react-phone-number-input/style.css'

axios.defaults.baseURL = process.env.REACT_APP_API_BASE_URL;

ReactDOM.render(
  <GlobalProvider>
    <DeviceTypeProvider>
      <App />
    </DeviceTypeProvider>
  </GlobalProvider>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

// Register service worker
serviceWorkerRegistration.register();